export default function(e){return String(e).replace(/[^\d]/g,"")};
//# sourceMappingURL=index.m.js.map
